import { default as ResetStyle } from '../reset.style';
import { default as ConsoledefaultStyle } from '../console/default.style';
import ChkIcon from '../common/chk.svg';
import ChkOnIcon from '../common/chk_on.svg';

const defaultStyle = `
    ${ResetStyle}
    /*------로그인페이지------*/
    #login_container {
      display: flex;
      height: 100%;
      box-sizing: border-box;
      overflow:hidden;
    }
    #login_container .bg_img {
      width: 60%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      box-sizing: border-box;
      z-index: 999;
      overflow: hidden;
    }
    #login_container .bg_img_hd {
      padding: 15.5vh 50px 0 50px;
    }
    #login_container .bg_img_hd h1 {
      font-size: 3.5vw;
      font-weight: 900;
      line-height: 1.3;
      text-align: left;
      color: #111111;
      word-break: break-word;
      letter-spacing: -1px;
    }
    #login_container .m_brd_logo {
      display: none;
    }
    #login_container .login_inform {
      width: 40%;
      padding: 15.5vh 20px;
      box-sizing: border-box;
      background: #fff;
      overflow-y: auto;
    }
    #login_container .login_inform .brd_logo {
      max-width: 360px;
      max-height: 60px;
      line-height: inherit;
      margin: 0px auto 40px;
    }
    #login_container .login_inform .brd_logo h3 {
      line-height: 59px;
      font-size: 35px;
      font-weight: bold;
    }
    #login_container .login_inform .brd_logo img {
      width: auto;
      height: 100%;
      display: block;
      margin: 0 auto;
      max-height:60px;
    }
    #login_container .login_inform_wrap input {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
    }
    input:-internal-autofill-selected {
      background-color: #fff !important;
    }
    #login_container .login_inform_list {
      display: flex;
      align-items: center;
      width: 360px;
      justify-content: center;
      margin: 0 auto;
    }

    #login_container .login_inform_list .login_inform_list_div {
      width: 100%;
      text-align: left;
    }
    #login_container .login_inform_list .login_inform_list_div span {
      display: inline-block;
      font-size: 18px;
      color: #111;
      font-weight: bold;
    }
    #login_container .login_inform_list .login_inform_list_div span:after {
      content: "";
      display: block;
      width: 12px;
      height: 2px;
      background: #111;
      margin-top: 5px;
    }
    #login_container .login_inform_list li {
      width: 40%;
      height: 30px;
      line-height: 30px;
      margin-bottom: 5px;
      box-sizing: border-box;
    }

    #login_container .login_inform_list li span {
      position: relative;
      font-size: 16px;
      text-align: center;
      box-sizing: border-box;
      padding-bottom: 7px;
      font-weight: bold;
      color: #cccccc;
      display: block;
      cursor: pointer;
    }
    #login_container .login_inform_list li span:after {
      content: "";
      position: absolute;
      display: block;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background: #ccc;
    }
    #login_container .login_inform_list li.active span:after,
    #login_container .login_inform_list li:hover span:after {
      height: 2px;
      background: #111111;
    }
    #login_container .login_inform_list li.active span,
    #login_container .login_inform_list li:hover span {
      color: #111111;
    }
    #login_container .login_box {
      max-width: 360px;
      margin: 30px auto 0;
    }
    #login_container .login_box .login_input_div {
      position: relative;
      margin-bottom: 10px;
    }
    #login_container .member_box .login_input_div:last-child {
      margin-bottom: 0;
    }
    #login_container .login_box .login_input_div img {
      position: absolute;
      top: 50%;
      right: 12px;
      transform: translateY(-50%);
    }
    #login_container .login_box input.login_input {
      width: 100%;
      font-size: 13px;
      height: 60px;
      border-radius: 4px;
      padding: 10px 50px 10px 20px;
      outline: #111111;
      box-sizing: border-box;
      background-color: #f7f7fa;
      border: 2px solid rgba(247, 247, 250, 1);
    }
    #login_container .login_box input.login_input:focus {
      border: 2px solid #6a6af8;
      background: rgba(247, 247, 250, 1);
    }
    #login_container .login_box input.login_input:-webkit-autofill,
    #login_container .login_box input.login_input:-webkit-autofill:hover,
    #login_container .login_box input.login_input:-webkit-autofill:focus,
    #login_container .login_box input.login_input:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 30px rgba(247, 247, 250, 1) inset !important;
    }
    

    #login_container .login_box input.login_input:last-child {
      margin-bottom: 0;
    }
    #login_container .login_box input.login_input::placeholder {
      font-size: 13px;
      text-align: left;
      line-height: 1.63;
      color: #888888 !important;
    }
    #login_container .id_save {
      margin: 20px 0;
    }
    #login_container .id_save label,
    #login_container .agree_form label {
      display: flex;
      align-items: center;
      font-size: 13px;
      line-height: initial;
      text-align: left;
      color: #666666;
    }
    #login_container .id_save input,
    #login_container .agree_form input {
      display: none;
    }
    #login_container .id_save input + label#chk_label span,
    #login_container .agree_form input + label#chk_label span {
      display: inline-block;
      width: 24px;
      height: 24px;
      background: url("${ChkIcon}");
      cursor: pointer;
      margin-right: 6px;
    }
    #login_container .id_save input:checked + label#chk_label span,
    #login_container .agree_form input:checked + label#chk_label span {
      background: url("${ChkOnIcon}");
    }

    #login_container .login_enter {
      width: 100%;
      height: 48px;
      line-height: 48px;
      border-radius: 4px;
      background-color: #6a6af8;
    }
    #login_container .login_enter span {
      display: block;
      font-size: 16px;
      line-height: 48px;
      color: #ffffff;
      cursor: pointer;
      text-align: center;
    }
    #login_container .member_find ul {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 20px;
    }
    #login_container .member_find ul li {
      width: 33.33%;
    }
    #login_container .member_find ul li a {
      position: relative;
      font-size: 16px;
      display: block;
      line-height: 1.63;
      text-align: left;
      color: #666666;
      text-align: center;
    }

    #login_container .member_find ul li a:after {
      content: "";
      position: absolute;
      top: 50%;
      right: 0;
      transform: translate(-50%, -50%);
      display: inline-block;
      margin: 0 auto;
      width: 1px;
      height: 11px;
      background: #ccc;
    }
    #login_container .member_find ul li:last-child a:after {
      content: none;
    }

    #login_container .psc_box .psc_box1 > div {
      text-align: left;
      margin-bottom: 20px;
    }
    #login_container .psc_hd {
      display: flex;
      justify-content: space-between;
    }
    #login_container .psc_hd p {
      position: relative;
      width: 28px;
      height: 28px;
      border-radius: 7px;
      cursor: pointer;
      background: #fff;
      box-shadow: 0 3px 3px #efefef;
    }
    #login_container .psc_hd p img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    #login_container .psd_ft {
      margin-top: 20px;
    }
    #login_container .psd_ft,
    #login_container .gst_hd {
      background: repeating-linear-gradient(
        -45deg,
        #ffeded,
        #ffeded 2px,
        #fff 0,
        #fff 5px
      );
      padding: 20px;
      box-sizing: border-box;
      font-size: 11px;
      word-break: normal;
      line-height: 1.45;
      text-align: left;
      color: #999999;
      margin-top: 20px;
    }
    #login_container .psc_box2 > p {
      font-size: 13px;
      line-height: 1.63;
      text-align: left;
      color: #666666;
      margin-bottom: 20px;
    }
    #login_container .login_box .gst_inform_message{
      text-align: left;
      margin-bottom: 18px;
    }
    #login_container .login_box .gst_inform_message span{
      font-size: 13px;
      word-break: keep-all;
      line-height: 1.69;
      color: #666;
    }
    #login_container .login_box .login_session {
      width: 100%;
      height: auto;
      padding: 20px;
      border-radius: 4px;
      text-align: left;
      background-color: #f7f7fa;
      margin-bottom: 10px;
      border: 2px solid #fff;
      box-sizing: border-box;
      transition: all 0.3s;
      cursor: pointer;
      overflow:hidden;
    }

    #login_container .login_box .login_session.active,
    #login_container .login_box .login_session:hover {
      background: #fff;
      border: 2px solid #6a6af8;
      box-sizing: border-box;
      box-shadow: 6px 6px 10px 0px rgb(106 106 248 / 20%);
    }

    #login_container .login_box .login_session .login_session_h3 {
      font-size: 15px;
      text-align: left;
      color: #333333;
      font-weight: bold;
      line-height: 1.71;
    }
    #login_container .login_box .login_session .login_session_h4 {
      width: 85%;
      overflow: hidden;
      white-space: normal;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      display: -webkit-box;
      word-break: break-all;
    }
    #login_container .login_box .login_session .login_session_h4 a {
      font-size: 20px;
      font-weight: bold;
      line-height: 1.5;
      text-align: left;
      color: #333333;
      word-break: keep-all;
    }
    #login_container .login_box .login_session .login_session_p {
      text-align: left;
      line-height: initial;
      font-size: 12px;
      color: #666666;
      margin-top:20px;
    }
    .gst_session_hd {
      display: flex;
      justify-content: space-between;
      margin-bottom: 13px;
    }
    .gst_session_hd .morebtn {
      position: relative;
      width: 28px;
      height: 28px;
      border-radius: 7px;
      cursor: pointer;
      background: #fff;
      box-shadow: 0 3px 3px #efefef;
    }

    .gst_session_hd .morebtn img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(90deg);
      display: inline-block;
      transition: all 0.3s;
    }

    .gst_session_hd .morebtn.active img {
      transform: translate(-50%, -50%) rotate(-90deg);
      transition: all 0.3s;
    }

    .gst_session .gst_session_sub .login_input_div:first-child { margin-top: 20px; }
    .gst_session .gst_session_sub { cursor: auto; }

    .gst_session .agree_form,
    .login_box .agree_form{ margin: 20px 0 30px; }
    .gst_session .agree_form ul li,
    .login_box .agree_form ul li{ display: flex; justify-content: space-between;  margin-bottom: 20px; color: #666666; align-items: center; }
    .gst_session .agree_form ul li:last-child,
    .login_box .agree_form ul li:last-child{ margin-bottom: 0;}
    .gst_session .agree_form ul li a,
    .login_box .agree_form ul li a{ color: #666666; text-decoration: underline;}
    .gst_session .agree_form ul li p,
    .login_box .agree_form ul li p{ display: flex; align-items: center;}
    .gst_session .agree_form ul li p span,
    .login_box .agree_form ul li p span{ display: block; line-height: initial;}

    #login_container .cs_container {
      max-width: 360px;
      margin: 40px auto 30px;
      text-align: left;
      line-height: 1.5;
    }
    #login_container .cs_container h4 {
      position: relative;
      font-size: 13px;
      color: #111;
      margin-bottom: 10px;
      line-height: 1.5;
      padding-top: 10px;
      font-weight: bold;
    }
    #login_container .cs_container h4:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      display: inline-block;
      width: 10px;
      height: 2px;
      background: #111;
    }
    #login_container .cs_container p {
      color: #999999;
      font-size: 13px;
      line-height: 1.63;
    }

    #login_container .bg_img_ft {
      max-width: 360px;
      margin: 0 auto;
      font-size: 15px;
      line-height: 1.54;
      text-align: left;
      border-top: 1px solid #ccc;
      padding-top: 20px;
    }
    #login_container .bg_img_ft table{
      border: none;
      border-collapse: collapse;
      empty-cells: show;
      margin-bottom: 1em;
      margin-top: 1em;
      max-width: 100%;
    }
    #login_container .bg_img_ft table tbody tr td{
      border: 1px solid #dadada;
      min-width: 2em;
      padding: 0.4em;
      -webkit-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
      vertical-align: middle;
    }
    #login_container .bg_img_ft .ft_info2 {
      font-size: 13px;
      margin-bottom: 10px;
      line-height: normal;
    }
    #login_container .bg_img_ft .ft_info3 {
      margin-bottom: 30px;
    }
    #login_container .bg_img_ft .ft_info3 span {
      font-size: 13px;
      line-height: normal;
      color: #999999;
      margin-bottom: 30px;
    }

    #login_container pre {
      font-family: "Noto Sans KR", sans-serif;
      font-weight: normal;
      font-size: 13px;
      line-height: 1.54;
      white-space: break-spaces;
      word-break: keep-all;
      color: #666666;
    }
    .none_event{background:#f7f7fa; padding:40px 0; text-align:center;}
    .none_event span{color:#666;}
    .m_login_footer {
      display: none;
    }
    /*=================미디어 쿼리=====================*/
    @media (min-width: 768px) and (max-width: 1023px) {
      #login_container .login_inform_list,
      #login_container .login_box {
        width: 100%;
      }
    }
    
    @media (max-width: 767px) {
      body,
      html {
        min-height: auto;
      }
      #login_container {
        display: block;
        min-height: auto;
        height: auto;
      }
      #login_container .bg_img {
        position: relative;
        display: block;
        width: 100%;
        min-height: 326px;
        padding: 0px;
      }
      #login_container .login_inform_wrap {
        padding: 0;
      }
      .bg_img_hd {
        position: absolute;
        bottom: 20px;
        left: 20px;
        padding: 0;
      }
      .bg_img_hd img {
        width: 100%;
      }
      .bg_img_hd h1 {
        font-weight: 900;
        line-height: 1.29;
        text-align: left;
        color: #111111;
        padding-right: 20px;
      }

      .m_hd_fixed {
        background: #fff;
      }
      #login_container .m_brd_logo {
        display: block;
        height: 60px;
        line-height: 60px;
        padding: 10px 0 10px 20px;
        box-sizing: border-box;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        transition: all 0.3s;
        z-index: 999;
      }

      #login_container .m_brd_logo img {
        display: block;
        width: auto;
        height: -webkit-fill-available;
        line-height: 40px;
      }

      #login_container .bg_img_ft {
        max-width:100%;
        border-top:0;
        padding:20px;
        background:#f7f7fa;
      }

      #login_container .login_inform {
        width: 100%;
        padding: 80px 0 0;
      }
      #login_container .login_inform .brd_logo{
        margin: 0px auto 80px;
      }
      #login_container .login_inform_list {
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
      }
      #login_container .login_box {
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        max-width:unset;
      }
      #login_container .cs_container {
        max-width: 100%;
        margin: 40px 0 50px;
        padding: 0 20px;
      }
      #login_container .m_login_footer {
        display: block;
        width: 100%;
        background-color: #f7f7fa;
        padding: 30px 20px;
        box-sizing: border-box;
        text-align: left;
        word-break: break-all;
      }
      #login_container .m_login_footer .ft_info {
        font-size: 15px;
        line-height: 1.71;
        margin-bottom: 0;
      }
      #login_container .m_login_footer .ft_info2 {
        font-weight: bold;
        line-height: 1.5;
        text-align: left;
        color: #333333;
        margin-bottom: 10px;
      }
      #login_container .m_login_footer .ft_info3 span {
        color: #999999;
        line-height: 1.45;
      }
      #login_container .m_login_footer .ft_info3 {
        margin-bottom: 33px;
      }
    }
    /*============로그인 페이지 css End==============*/

    /*공통 pc*/
    .content-area {
      height:100%;
      box-sizing: border-box;
      margin-bottom:100px;
    }
    #root {
      height: 100%;
    }
    .onair_btn {
      position: relative;
      display: inline-block;
      width: 70px;
      height: 24px;
      border-radius: 12px;
      box-sizing: border-box;
      border: 1px solid #ea3131;
      background: #ea3131;
      text-align: center;
      line-height: initial;
    }
    
    .onair_btn small {
      display: inline-block;
      width: 100%;
      position: absolute;
      top: 45%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 12px;
      color: #fff;
      font-weight: 400;
    }
    
    .livebtn {
      position: relative;
      display: inline-block;
      width: 57px;
      height: 24px;
      text-align: center;
      background: #fff;
      border: 1px solid #723ec6;
      border-radius: 12px;
      box-sizing: border-box;
      margin-right: 6px;
    }
    .livebtn small {
      display: inline-block;
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #723ec6;
      font-size: 12px;
      font-weight: 400;
    }
    .ondemandbtn {
      position: relative;
      display: inline-block;
      width: 96px;
      height: 24px;
      text-align: center;
      background: #fff;
      border: 1px solid #94ad51;
      border-radius: 12px;
      box-sizing: border-box;
      margin-right:6px;
    }
    .ondemandbtn small {
      display: inline-block;
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #94ad51;
      font-size: 12px;
      font-weight: 400;
    }
    
    .basic_btn {
      display: inline-block;
      width: 160px;
      height: 48px;
      line-height: 48px;
      background: #6a6af8;
      border-radius: 4px;
      color: #fff;
      font-size: 16px;
      text-align: center;
    }
    .basic_btn:hover {
      color: #fff;
    }
    
    /*======공통 모바일======*/
    @media (max-width: 767px) {
      .event_area .livebtn {
        margin-top: 0;
      }
      .event_area .ondemandbtn{
        margin-top: 0;
      }
    }
    
    /*==========헤더==========*/
    #header {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1001;
      padding: 0 20px;
      width: 100%;
      height: 80px;
      box-sizing: border-box;
    }
    #header .header {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
      height: 80px;
      background: none;
      align-items: center;
      margin-bottom: 20px;
      background: none;
      box-sizing: border-box;
      transition: all 0.3s;
      z-index: 999;
    }
    #header .header h1 {
      max-width: 200px;
      max-height: 60px;
      line-height: 60px;
    }
    #header .header h1 a:hover {
      color: none;
    }
    #header .header.fixed {
      position: fixed;
      width: 100%;
      top: 0;
      left: 0;
      background: #fff;
      padding: 0 20px;
      box-sizing: border-box;
      transition: all 0.3s;
      height: 80px;
      border-bottom: 1px solid #ccc;
    }
    #header .header > a {
      max-height: 40px;
      width: 100%;
      max-width: 240px;
      position: relative;
      height: 40px;
    }
    #header .header > a > img {
      max-width: inherit; max-height: inherit; position:absolute; top:50%; left:0; transform:translateY(-50%);
    }
    .header .menubtn {
      width: 50px;
      height: 65px;
      line-height: 10px;
      background: #6a6af8;
      margin: -20px 0 0 0;
      box-shadow: 2px 2px 8px 0px rgba(106, 106, 248, 0.45);
      border-radius: 0 0 2px 2px;
      cursor: pointer;
      z-index: 1000;
      transition: all 0.3s;
      padding: 0;
    }
    .header .menubtn.on {
      width: 50px;
      height: 50px;
      margin: -30px 0 0 0;
    }
    .header .menubtn.on .line_box {
      margin: 0 auto;
    }
    .header .line_box {
      position: relative;
      width: 40px;
      height: 40px;
      margin: 20px auto;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-flow: column;
      transition: all 0.3s;
    }
    
    .header .line_box .line {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: block;
      width: 22px;
      height: 3px;
      background: #fff;
      margin: 0 auto;
      border-radius: 3px;
      transition: all 0.3s;
    }
    
    .header .line_box .line1 {
      transform: translate(-50%, -8.5px);
    }
    .header .menubtn.on .line_box .line1 {
      transform: translate(-50%, -50%) rotate(45deg);
    }
    
    .header .line_box .line3 {
      transform: translate(-50%, 5.5px);
    }
    .header .menubtn.on .line_box .line3 {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
    .header .menubtn.on .line_box .line2 {
      width: 4px;
      height: 4px;
      background: #6a6af8;
      top: 21px;
      left: 21px;
      border-radius: 0;
    }
    
    .header-freeze {
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: transparent;
      z-index: -1;
      transition: all 0.3s;
    }
    .header-freeze.on {
      display: block;
      z-index: 200;
      background: rgba(0, 0, 0, 0);
      transition: all 0.3s;
    }
    
    /*===========헤더 메뉴 버튼===========*/
    .menu_box {
      position: fixed;
      top: -700px;
      right: 0;
      z-index: 999;
      width: 300px;
      border-top: 2px solid #6a6af8;
      background: #fff;
      box-shadow: 3px 6px 20px 0 rgba(0, 0, 0, 0.16);
      transition: all 0.3s;
      color: #666;
      overflow-y: auto;
      max-height: 100%;
    }
    .menu_box.on {
      top: 0;
      transition: all 0.3s;
    }
    .menu_box > li {
      position: relative;
      padding: 14px 20px;
      border-bottom: 1px solid #eeeeee;
    }
    .menu_box_info p {
      font-size: 12px;
      color: #666;
      line-height: 2.17;
    }
    .menu_box_info span {
      font-size: 18px;
      line-height: 1.33;
      display: block;
      font-weight: bold;
      color: #333;
    }
    
    .menu_box_list a,
    .menu_box_loginfo span {
      display: block;
      line-height: 1;
      text-align: left;
      color: #666666;
      cursor: pointer;
      font-size:16px;
    }
    
    .menu_box_list > ul > li {
      display: flex;
      align-items: center;
      padding: 10px 0;
    }
    .menu_box_loginfo span {
      padding: 10px 0;
    }
    .menu_box_loginfo img {
      display: inline-block;
      padding-right: 30px;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
    }
    
    /*======헤더 모바일======*/
    @media (max-width: 767px) {
      #header,
      #header .header {
        padding: 0 10px 0 20px;
      }
      #header .header {
        height: 60px;
      }
      #header .header.fixed {
        padding: 0 10px 0 20px;
        height: 60px;
        border-bottom: 1px solid #999;
      }
      #header .header > a {
        max-width:160px; max-height: 40px; width: inherit;
      }
      .header_wrap {
        padding-top: 100px;
      }
      .header_wrap h2 {
        font-size: 30px;
      }
      .header .menubtn {
        width: 40px;
        height: 50px;
        margin: -10px 0 0 0;
        border-radius: 0 0 2px 2px;
      }
      .header .menubtn.on {
        width: 40px;
        z-index: 1000;
      }
      .header .menubtn.on .line_box {
        margin-top: 10px;
      }
      .header .line_box {
        width: 100%;
        height: 40px;
        margin-top: 10px;
      }
      .header .line_box.on {
        z-index: 1000;
      }
      .header_wrap .mypage_list li {
        margin-right: 30px;
      }
      .menu_box {
        position: inherit;
        top: -900px;
        right: 0;
        width: 100%;
        max-height: 100%;
        overflow-y: auto;
      }
      .menu_box.on {
        top: 0;
      }
    }
    
    /*==========데이터 없을때, 로딩이미지==========*/
    .loading_img {
      background: #111;
      top: 0;
      left: 0;
    }
    .nonedata_box {
      margin: 100px 0;
      text-align: center;
    }
    .nonedata_box p {
      margin-top: 20px;
      font-weight: bold;
      color: #333333;
      font-size: 16px;
    }
    
    /*==========메인페이지 공통 피시==========*/
    .main_header_bnr_box{
      position: relative;
      height: 500px;
      overflow-x: hidden;
    }
    .main_header_bnr_box img{
      display: block;
      height: 100%;
      object-position: 50% 50%;
      margin: 0 auto;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
    .main_header_bnr_box img.main_header_bnr_box_img2{
      max-width: 1180px;
      object-fit: cover;
      text-align: center;
      margin: 0 auto;
    }
    @media (max-width:1180px){
      .main_header_bnr_box{height:auto; padding: 21%;}
      .main_header_bnr_box img{ width:1180px;}
      .main_header_bnr_box img.main_header_bnr_box_img1{display:none;}
    }
    @media (max-width:767px){
      .main_header_bnr_box{padding: 20.40%;}
    }
    .main_header_bnr {
      position: relative;
      background-repeat: no-repeat;
      margin: 0 auto;
      height: 580px;
      box-sizing: border-box;
      padding: 0 20px;
      overflow: hidden;
    }
    .main_header_bnr img {
      display: block;
      margin: 0 auto;
      width: 100%;
    }
    
    .sub_bg_img_hd {
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 100%;
      max-width: 1180px;
      margin: 0px auto;
      padding-bottom: 20px;
      text-align: left;
    }
    @media (max-width:1220px){
      .sub_bg_img_hd {padding-left:20px; padding-right:20px;}
    }
    .sub_bg_img_hd img {
      position: absolute;
      bottom: 20px;
      left: 0;
    }
    
    .sub_bg_img_hd h1 {
      font-size: 60px;
      font-weight: 900;
      line-height: 1.3;
      text-align: left;
      color: #111111;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow-wrap: break-word;
      word-break: keep-word;
    }
    .main_inform {
      width: 100%;
      padding: 0 20px;
      box-sizing: border-box;
      border-bottom: 1px solid #eeeeee;
    }
    .main_inform_text {
      display: flex;
      align-items: center;
      padding: 20px 0;
      box-sizing: border-box;
    }
    .main_inform_text strong,
    .main_inform_text p {
      font-size: 13px;
      line-height: initial;
      text-align: left;
      margin-right: 30px;
    }
    .main_inform_text strong {
      color: #111111;
      font-weight: bold;
    }
    .main_inform_text p {
      color: #666666;
    }
    .main_inform_2 {
      display: none;
      width: 100%;
      border-bottom: 1px solid #eeeeee;
      padding: 30px 0;
    }
    .main_inform_2 ul {
      max-width: 1180px;
      margin: 0px auto;
      display: flex;
      justify-content: space-around;
    }
    .main_inform_2 ul li {
      width: 50%;
    }
    .main_inform_2 ul li div {
      display: flex;
      align-items: center;
      justify-content: center;
      width: max-content;
      margin: 0 auto;
      cursor: pointer;
    }
    .main_inform_2 ul li:first-child {
      border-right: 1px solid #eee;
    }
    .main_inform_2 ul li span {
      display: inline-block;
      margin-left: 10px;
      font-size: 24px;
      font-weight: bold;
      color: #333333;
    }
    
    .main_section {
      padding: 0 20px;
    }
    .subpage_box table{
      border: none;
      border-collapse: collapse;
      empty-cells: show;
      margin-bottom: 1em;
      margin-top: 1em;
      max-width: 100%;
    }
    .subpage_box table tbody tr td{
      border: 1px solid #dadada;
      min-width: 2em;
      padding: 0.4em;
      -webkit-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
      vertical-align: middle;
    }
    .subpage_box img {
      max-width: 1024px;
      width: 100% !important;
    }
    @media (max-width:767px){
      .main_header_bnr_box img.main_header_bnr_box_img2{object-fit:contain;}
    }
    /*======메인페이지 공통 모바일 가로모드, 태블릿======*/
    @media (min-width: 568px) and (max-width: 767px) {
      .main_header_bnr {
        height: 450px;
      }
      .sub_bg_img_hd {
        padding-bottom: 50px;
      }
      .subpage_box{margin-top:20px;}
    }
    /*======메인페이지 공통 모바일======*/
    @media (max-width: 767px) {
      .main_header_bnr {
        display: block;
        min-height: 326px;
        height: 326px;
      }
      .main_header_bnr span {
        display: block;
      }
      .sub_bg_img_hd {
        padding-bottom: 0;
        position: absolute;
        top: auto;
        bottom: 20px;
        left: 0px;
        transform: unset;
        width: 100%;
      }
      .sub_bg_img_hd img {
        width: 100%;
      }
      .sub_bg_img_hd h1 {
        font-size: 34px;
      }
      .main_inform_text {
        display: block;
        height: auto;
        padding: 18px 0;
        box-sizing: border-box;
      }
      .main_inform_text strong {
        display: block;
        margin-bottom: 6px;
      }
      .main_inform_text p {
        display: inline-block;
        font-size: 15px;
        margin-right: 20px;
      }
      .main_inform_text p:last-child {
        margin-right: 0;
      }
      .subpage_box{margin-top:20px;}
      .subpage_box img{
        width:100% !important;
      }
    }
    
    /*=========리스트페이지 피시==========*/
    
    .event_area,
    .upcoming_area {
      box-sizing: border-box;
    }
    
    .event_area h2 {
      font-size: 36px;
      font-weight: bold;
      color: #333333;
      margin: 46px 0 20px;
      line-height: 1.5;
    }
    .upcoming_area h2 {
      font-size: 36px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 20px;
      line-height: 1.5;
    }
    .main_area_li {
      display: flex;
      width: 100%;
      align-items: center;
      padding: 30px;
      box-sizing: border-box;
    }
    @media (hover: hover) {
      .main_area_li:hover {
        background: #f7f7fa;
        border-radius: 32px;
      }
    }
    
    .main_area_img_box {
      position: relative;
      width: 140px;
      height: 140px;
      margin-right: 35px;
      cursor: pointer;
    }
    
    .main_area_img {
      display: block;
      width: inherit;
      height: inherit;
      border-radius: 20px;
    }

    .main_area_li .onair_btn {
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
    }
    
    .state_btn_box {
      display: flex;
      margin-bottom: 7px;
    }
    .main_area_text_box {
      width: 100%;
    }
    .upcoming_area_text_box {
      width: 100%;
    }
    
    .main_area_text_box h4 {
      margin-bottom: 7px;
      overflow: hidden;
      white-space: normal;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      display: -webkit-box;
      word-break: break-word;
      cursor: pointer;
    }
    .main_area_text_box h4 a {
      display: block;
      color: #333333;
      font-size: 22px;
      font-weight: bold;
      font-stretch: normal;
      text-align: left;
      line-height: 1.5;
    }
    
    .main_area_text_box p {
      font-size: 14px;
      line-height: 1.54;
      text-align: left;
      color: #888888;
      word-break: keep-all;
    }
    
    .basic_btn a {
      display: block;
      font-size: 16px;
      text-align: center;
      color: #fff;
    }
    .main_section .swiper-container {
      display: none;
    }
    
    /*======리스트페이지 공통 모바일======*/
    @media (max-width: 767px) {
      .main_section{padding:0;}
      .event_area,
      .upcoming_area {
        padding: 0;
      }
      .event_area h2,
      .upcoming_area h2 {
        margin: 30px 0 20px;
        padding-left: 20px;
        font-size: 30px;
      }
      .main_section{padding:0;}
      .main_area_li{padding:30px 20px; align-items:flex-start;}
      .main_area_li:hover{background:none;}
      .main_area_img_box{width:86px; height:86px; margin-right:10px;}
      .event_area .livebtn{width:57px; height:24px;}
      .event_area .ondemandbtn{width:96px; height:24px;}
      .state_btn_box,.main_area_text_box h4{margin-bottom:4px;}
      .main_area_text_box h4{-webkit-line-clamp:4;}
      .main_area_li .onair_btn{width:70px; height:24px; bottom:8px;}
      .main_area_text_box h4 a{font-size:20px;line-height:1.4;}
    }
    
    /*=====마이페이지 헤더 공통=====*/
    .mypage_header_bnr {
      background: url("https://cdn.onoffevent.com/subpage/siteimg.png");
      background-size: cover;
      background-repeat: no-repeat;
      margin: 0 auto;
      min-height: 215px;
      box-sizing: border-box;
    }
    .mypage_tab_menu_wrapper {
      padding: 0 20px;
    }
    .mypage_tab_menu {
      max-width: 1180px;
      margin: 0 auto;
      margin-top: -117px;
    }
    .mypage_tab_menu h2 {
      font-size: 40px;
      font-weight: 900;
      line-height: 1.48;
      text-align: left;
      color: #111111;
      margin-bottom: 20px;
    }
    
    .mypage_tab_menu .mypage_list .swiper-slide {
      display: inline-block;
      width: auto !important;
    }
    .mypage_tab_menu .mypage_list li,
    .mypage_tab_menu .mypage_list .swiper-slide {
      display: inline-block;
      margin-right: 40px;
      cursor: pointer;
      width: auto;
    }
    .mypage_tab_menu .mypage_list li:hover,
    .mypage_tab_menu .mypage_list li.active,
    .mypage_tab_menu .mypage_list .swiper-slide:hover,
    .mypage_tab_menu .mypage_list .swiper-slide.active {
      border-bottom: 2px solid #111;
    }
    .mypage_tab_menu .mypage_list li:hover a,
    .mypage_tab_menu .mypage_list li.active a,
    .mypage_tab_menu .mypage_list .swiper-slide:hover a,
    .mypage_tab_menu .mypage_list .swiper-slide.active a {
      color: #111111;
    }
    .mypage_tab_menu .mypage_list li a,
    .mypage_tab_menu .mypage_list .swiper-slide a {
      display: block;
      font-size: 16px;
      font-weight: bold;
      line-height: 1.5;
      text-align: left;
      color: #999999;
      padding-bottom: 12px;
    }
    /*======마이페이지 헤더 공통 모바일======*/
    @media (max-width: 767px) {
      .mypage_tab_menu {
        margin-top: -96px;
      }
      .mypage_tab_menu h2 {
        font-size: 30px;
        padding-left:20px;
      }
      .mypage_tab_menu .mypage_list li,
      .mypage_tab_menu .mypage_list .swiper-slide {
        margin-right: 30px;
      }
    
      .mypage_tab_menu .mypage_list li a {
        padding-bottom: 7px;
      }
    }
    
    /*=====개인정보수정======*/
    
    .modify_wrap {
      padding: 130px 20px 0;
      box-sizing: border-box;
    }
    
    .modify_wrapper {
      max-width: 1180px;
      margin: 0 auto;
      width: 100%;
    }
    .modify_wrapper ul:after {
      content: "";
      display: block;
      clear: both;
    }
    .modify_wrapper ul li {
      float: left;
      width: calc(50% - 20px);
      margin-bottom: 24px;
    }
    .modify_wrapper ul li:nth-child(odd) {
      margin-right: 40px;
    }
    .modify_wrapper ul li:last-child,
    .modify_wrapper ul li:nth-last-child(2) {
      margin-bottom: 0;
    }
    .modify_wrapper .mypage_label {
      display: block;
      font-size: 15px;
      font-weight: bold;
      line-height: 19px;
      text-align: left;
      color: #4e4b7b;
      margin-bottom: 5px;
    }
    
    .modify_wrapper .mypage_input {
      font-size: 15px;
      font-weight: normal;
      border: none;
      outline: none;
      border-bottom: 1px dotted #ccc;
      width: 100%;
      height: 40px;
      color: #ccc;
    }
    .modify_wrapper .mypage_input::placeholder {
      font-size: 13px;
      line-height: 2;
      text-align: left;
      color: #cccccc;
    }
    
    .sign_enter {
      width: 200px;
      height: 58px;
      margin: 40px auto;
      line-height: 58px;
      border-radius: 4px;
      background-color: #6a6af8;
    }
    .sign_enter span {
      display: block;
      font-size: 16px;
      line-height: 58px;
      color: #ffffff;
      cursor: pointer;
      text-align: center;
    }
    /*===개인정보수정 모바일===*/
    @media (max-width: 767px) {
      .modify_wrap {
        padding: 40px 0;
      }
      .modify_wrap .modify_wrapper {
        display: block;
        padding: 0 20px;
        box-sizing: border-box;
      }
      .modify_wrap .modify_wrapper ul:first-child {
        margin-right: 0;
        margin-bottom: 30px;
      }
      .modify_wrap .modify_wrapper ul {
        width: 100%;
      }
      .modify_wrap .modify_wrapper li {
        width: 100%;
      }
      .modify_wrapper ul li:nth-last-child(2) {
        margin-bottom: 20px;
      }
    }
    /*=====초대장=====*/
    .m_invitation_wrap {
      display: none;
    }
    .invitation_wrap {
      margin: 0 auto;
      padding: 130px 0 0;
      box-sizing: border-box;
    }
    .invitation_wrap .swiper-container {
      padding: 60px;
    }
    .invitation_wrap .swiper-container .swiper-wrapper {
      position: static;
    }
    .invitation_wrap .swiper-container .swiper-wrapper .swiper-slide {
      max-width: 700px !important;
      width: calc(100vw - 200px);
      border-radius: 12px;
      box-shadow: 6px 6px 30px 0px rgba(0, 0, 0, 0.16);
      margin: 0 auto;
    }
    .invitation_wrap .invitation_slider_div {
      height: 100%;
      width: calc(100vw - 200px);
      max-width: 700px !important;
      height: 400px;
      border-radius: 12px;
      box-shadow: 6px 6px 30px 0px rgba(0, 0, 0, 0.16);
      margin: 0 auto;
    }
    .invitation_wrap .back_flex {
      position: relative;
      height: inherit;
    }
    
    .invitation_wrap .back_left {
      background: #fff;
      width: 100%;
      height: 80%;
      border-radius: 12px 12px 0 0;
      padding: 0 30px;
    }
    .invitation_wrap .back_right {
      width: 100%;
      height: 20%;
      border-radius: 0 0 12px 12px;
      overflow: hidden;
      background-size: cover;
      background-repeat: no-repeat;
    }
    .invitation_wrap .back_right .back_right_inner{
      height: -webkit-fill-available;
      filter: blur(50px);
      transform: scale(2);
      background-size: cover;
      background-repeat: no-repeat;
    }
    .invitation_wrap .swiper-pagination {
      bottom: 20px;
    }
    .invitation_wrap .swiper-pagination-bullet,.m_invitation_wrap .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      background: #fff;
      border: 2px solid #373779;
      box-sizing: border-box;
      opacity: 1;
    }
    .invitation_wrap .swiper-pagination-bullet-active,.m_invitation_wrap .swiper-pagination-bullet-active {
      background: #373779;
    }
    .invitation_wrap .back_thumb {
      display: inline-block;
      margin-top: -30px;
      width: 140px;
      height: 140px;
      border-radius: 20px;
      box-shadow: 4px 4px 16px 0 #b9b9de;
      overflow: hidden;
    }
    .invitation_wrap .back_thumb img {
      display: block;
      width: 100%;
      height: 100%;
    }
    
    .invitation_wrap .back_desc {
      margin-top: 20px;
    }
    .invitation_wrap .back_desc h2 {
      margin-bottom: 10px;
      width: 100%;
      overflow: hidden;
      white-space: normal;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      display: -webkit-box;
      word-break: break-all;
    }
    .invitation_wrap .back_desc h2 a {
      font-size: 40px;
      font-weight: 900;
      line-height: 1.43;
      text-align: left;
      color: #111111;
    }
    
    .invitation_wrap .back_desc p {
      font-size: 16px;
      font-weight: 300;
      line-height: 1.5;
      text-align: left;
      color: #333333;
    }
    @media (max-width: 767px) {
      /*===초대장 모바일===*/
      .invitation_wrap {
        display: none;
      }
      .m_invitation_wrap {
        display: block;
        margin: 0 auto;
        padding: 20px 0px;
        box-sizing: border-box;
      }
      .m_invitation_wrap .swiper-container {
        padding: 40px;
      }
      .m_invitation_wrap .swiper-container .swiper-wrapper {
        position: static;
      }
      .m_invitation_wrap .swiper-container .swiper-wrapper .swiper-slide {
        width: 280px !important;
        height: 280px;
        border-radius: 12px;
        box-shadow: 6px 6px 30px 0 rgba(0, 0, 0, 0.16);
      }
      .m_invitation_wrap
        .swiper-container
        .swiper-wrapper
        .swiper-slide
        .invitation_wrap_slide_div {
        height: 100%;
      }
      .m_invitation_wrap .back_flex {
        height: inherit;
      }
    
      .m_invitation_wrap .back_left {
        background: #fff;
        width: 100%;
        height: 75%;
        border-radius: 12px 12px 0 0;
        padding: 0 20px;
      }
      .m_invitation_wrap .back_left .back_desc {
        margin-top: 10px;
      }
      .m_invitation_wrap .back_right {
        background: #ccc;
        width: 100%;
        height: 25%;
        border-radius: 0 0 12px 12px;
        overflow:hidden;
      }
      .m_invitation_wrap .back_right .back_right_inner{
        height: -webkit-fill-available;
        filter: blur(10px);
        transform: scale(1.5);
        background-size: cover;
        background-repeat: no-repeat;
      }
      .m_invitation_wrap .swiper-pagination {
        bottom: 10px;
      }

      .m_invitation_wrap .back_thumb {
        display: inline-block;
        width: 100px;
        height: 100px;
        margin-top: -20px;
        border-radius: 20px;
        box-shadow: 4px 4px 16px 0 #b9b9de;
        overflow: hidden;
      }
      .m_invitation_wrap .back_thumb img {
        width: 100%;
        height: 100%;
        border-radius: 20px;
        box-shadow: 4px 4px 16px 0 #b9b9de;
      }
      .m_invitation_wrap .back_desc {
      }
      .m_invitation_wrap .back_desc h2 {
        margin-bottom: 10px;
        overflow: hidden;
        white-space: normal;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        word-break: break-all;
      }
      .m_invitation_wrap .back_desc h2 a {
        font-size: 26px;
        font-weight: 900;
        line-height: 1.31;
        text-align: left;
        color: #111111;
      }
      .m_invitation_wrap .back_desc p {
        font-size: 12px;
        font-weight: 300;
        line-height: 1.57;
        text-align: left;
        color: #333333;
      }
    }
    /*=====참가 심포지엄=====*/
    .symposium_wrap {
      max-width: 1180px;
      margin: 0 auto;
      padding: 130px 0px;
    }
    .symposium_wrap .symposium_nav {
      margin-bottom: 20px;
    }
    .symposium_wrap .symposium_nav ul {
      display: flex;
    }
    
    .symposium_wrap .symposium_nav ul li {
      border-radius: 2px;
      background: #999999;
      margin-right: 2px;
    }
    .symposium_wrap .symposium_nav ul li.active,
    .symposium_nav ul li:hover {
      background: #7758fa;
    }
    .symposium_wrap .symposium_nav ul li button {
      display: inline-block;
      padding: 6px 12px;
      box-sizing: border-box;
      font-size: 16px;
      font-weight: normal;
      line-height: 1.3;
      color: #fff;
    }
    .symposium_wrap .symposium_list ul li {
      width: 100%;
      height: 120px;
      margin-bottom: 10px;
      background: #f7f7fa;
      border-radius: 6px;
    }
    .symposium_wrap .symposium_list ul li:last-child {
      margin-bottom: 0;
    }
    .symposium_wrap .symposium_list ul li a {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: initial;
      height: inherit;
      vertical-align: middle;
      padding: 0 40px 0 20px;
      box-sizing: border-box;
    }
    .symposium_wrap .symposium_list ul li a .symposium_list_text h2 {
      font-size: 22px;
      font-weight: bold;
      line-height: 1.5;
      text-align: left;
      color: #333333;
      margin-bottom: 10px;
    }
    .symposium_wrap .symposium_list ul li.active {
      background: #ededf7;
    }
    .symposium_wrap .symposium_list ul li a .symposium_list_text p {
      display: inline-block;
      font-size: 13px;
      line-height: 1.54;
      text-align: left;
      color: #888888;
    }
    .symposium_wrap .symposium_list ul li a .symposium_list_text p.sym_time {
      text-indent: 5px;
    }
    .symposium_wrap .symposium_list ul li a span {
      font-size: 20px;
      font-weight: bold;
      line-height: 1.45;
      text-align: right;
      color: #cccccc;
    }
    .symposium_wrap .symposium_list ul li.active a span {
      color: #111111;
    }
    .symposium_wrap .symposium_list ul li.active a span.not_participating {
      color: #ccc;
    }
    @media (max-width: 767px) {
      /*=====심포지엄 모바일=====*/
      .symposium_wrap {
        padding: 20px 0px;
      }
      .symposium_wrap .symposium_list ul li {
        height: auto;
      }
      .symposium_wrap .symposium_list ul li:las-child {
        margin-bottom: 0;
      }
      .symposium_wrap .symposium_list ul li a {
        display: block;
        padding: 20px;
      }
    
      .symposium_wrap .symposium_list ul li a .symposium_list_text h2 {
        font-size: 20px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #333333;
      }
      .symposium_wrap .symposium_list ul li a .symposium_list_text p {
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.63;
        letter-spacing: normal;
        text-align: left;
        color: #888888;
      }
      .symposium_wrap .symposium_list ul li a .symposium_list_text p.sym_time {
        text-indent: 0px;
        margin-bottom: 10px;
      }
      .symposium_wrap .symposium_list ul li a span {
        display: block;
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #cccccc;
      }
    }
    
    /*=====질문보관함=====*/
    .m_question_storage_wrap {
      display: none;
    }
    .storage_wrap {
      padding: 0 20px;
    }
    .storage_wrap_inner {
      max-width: 1180px;
      margin: 0 auto;
      padding: 75px 0 88px 0;
    }
    .storage_table_top {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }
    .storage_table_top > div {
      position: relative;
      display: flex;
      align-items: center;
    }
    .storage_table_top .table_select button {
      position: relative;
      background: #efefff;
      border: none;
      padding: 10px 22px 10px 12px;
      margin-right: 10px;
      cursor: pointer;
    }
    .table_select .table_btn_div {
      position: absolute;
      top: 40px;
      left: 0;
      box-shadow: 0 3px 20px 0 rgb(0 0 0 / 20%);
      border: 1px solid #4e4b7b;
      border-radius: 2px;
      padding: 9px 0;
      opacity: 0;
      visibility: hidden;
      transform: translateY(-20px);
      transition: all 0.1s;
      background: #fff;
      z-index: 9;
    }
    .table_select .table_btn_div.active {
      opacity: 1;
      visibility: visible;
      transform: translateY(0px);
      transition: all 0.1s;
    }
    .table_select .table_btn_div h2 {
      padding: 10px 15px 3px;
      color: #ccc;
    }
    .table_select .table_btn_ul a {
      display: block;
      padding: 2px 15px;
      cursor: pointer;
    }
    .table_select .table_btn_ul a:hover {
      background: #e7e7f9;
    }
    .storage_table_top input {
      border: none;
      border-bottom: 1px solid #ccc;
      width: 240px;
      height: 40px;
      padding-right: 30px;
    }
    .storage_table_top input::placeholder {
      color: #ccc;
    }
    .storage_table_top span {
      color: #666;
    }
    .storage_table_top img {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
      cursor: pointer;
    }
    .storage_table_top img.search_img {
      right: 0;
    }
    .storage_table_top img.search_cancel_img {
      left: 0;
      background: #f7f7fa;
      border-radius: 50%;
    }
    
    .question_storage_table {
      max-width: 1180px;
      margin: 0 auto;
      box-sizing: border-box;
      width:100%;
      table-layout: fixed;
    }
    .question_storage_table thead tr {
      text-align: center;
      line-height: 34px;
      background: #f7f7fa;
    }
    .question_storage_table thead tr th {
      position: relative;
      color: #4e4b7b;
      font-size: 13px;
      font-weight: bold;
    }
    .question_storage_table thead tr th span {
      position: absolute;
      top: 48%;
      transform: translateY(-50%);
      right: 30px;
    }
    .question_storage_table thead tr th span img:last-child {
      display: inline-block;
      margin-left: 1px;
    }
    .question_storage_table tbody tr {
      border-bottom: 1px solid #eeeeee;
    }
    .question_storage_table tbody tr td {
      padding: 20px;
      vertical-align: middle;
      color: #333;
      font-size: 13px;
      font-weight: normal;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .table_morebtn {
      position: absolute;
      top: 30px;
      right: 0;
      width: 145px;
      box-shadow: 0 3px 20px 0 rgb(0 0 0 / 20%);
      border: 1px solid #4e4b7b;
      border-radius: 2px;
      padding: 9px 0;
      opacity: 0;
      visibility: hidden;
      transform: translateY(-20px);
      transition: all 0.1s;
      background: #fff;
    }
    .table_morebtn.active {
      opacity: 1;
      visibility: visible;
      transform: translateY(0px);
      transition: all 0.1s;
    }
    .table_morebtn a {
      display: block;
      padding: 2px 15px;
      cursor: pointer;
      text-align: left;
    }
    .table_morebtn a:hover {
      background: #e7e7f9;
    }
    .table_pagination {
      margin-top: 20px;
    }
    .table_pagination ul {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .table_pagination > ul > li {
      cursor: pointer;
    }
    .table_pagination > ul > li:first-child {
      padding-right: 10px;
    }
    .table_pagination > ul > li:last-child {
      padding-left: 10px;
    }
    .table_pagination > ul > li > ul {
      padding: 0 10px;
    }
    .table_pagination > ul > li > ul > li > a {
      font-size: 13px;
      font-weight: 500;
      color: #ccc !important;
      cursor: pointer;
      padding: 0 10px;
    }
    .table_pagination > ul > li > ul > li > a.on,
    .table_pagination > ul > li > ul > li > a:hover {
      color: #333 !important;
    }
    .table_pagination a,
    .table_pagination img {
      display: block;
    }
    
    /*=====질문보관함 모바일=====*/
    @media (max-width: 767px) {
    }
    @media (max-width: 860px) {
      .storage_wrap {
        display: none;
      }
      .m_question_storage_wrap {
        display: block;
        padding: 20px;
      }
      .storage_wrap_inner {
        padding: 20px 0 80px 0;
      }
      .m_question_storage_wrap .storage_table_top {
        margin-bottom: 20px;
      }
      .m_question_storage_wrap .storage_table_top > div {
        width: 100%;
      }
      .m_question_storage_wrap .storage_table_top input {
        width: 100%;
      }
      .m_question_storage_wrap .storage_table_top input.isOpen {
        padding-left: 40px;
      }
      .m_question_storage_wrap .m_table_list > li {
        padding: 20px;
        background: #f7f7fa;
        margin-bottom: 20px;
      }
      .m_question_storage_wrap .m_table_list > li h2 {
        font-size: 13px;
        line-height: 1.54;
        color: #666;
        font-weight: normal;
        margin-bottom: 10px;
      }
      .m_question_storage_wrap .m_table_list > li p {
        font-size: 13px;
        font-weight: bold;
        line-height: 1.54;
        color: #333;
        margin-bottom: 10px;
      }
      .m_question_storage_wrap .m_table_list > li span {
        display: inline-block;
        font-size: 13px;
        line-height: 1.54;
        color: #666;
        margin-bottom: 10px;
      }
      .m_question_storage_wrap .m_table_list > li span:first-child:after {
        content: "";
        display: inline-block;
        margin: 0 6px;
        width: 1px;
        height: 6px;
        background: #ccc;
      }
      .m_question_storage_wrap .m_table_list > li small {
        display: inline-block;
        font-size: 11px;
        line-height: 1.45;
        color: #999;
      }
      .m_question_storage_wrap .m_table_list > li small:first-child {
        margin-right: 10px;
      }
      .m_question_storage_wrap .table_btn_more {
        margin-top: 20px;
        text-align: right;
      }
      .m_question_storage_wrap .table_btn_more > div {
        position: relative;
        display: inline-block;
      }
      .m_question_storage_wrap .table_btn_more > div a {
        word-break: keep-all;
      }
      .m_question_storage_wrap .table_btn_more img {
        cursor: pointer;
      }
    }
    
    /*==========사전등록 페이지==========*/
    .m_slide_con { display: none;}
    .sch_section { padding: 0 20px;}
    .sch_wrap {display: flex; box-sizing: border-box; margin-top:20px; }
    .sch_wrapper { width: calc(100% - 300px);padding-right: 30px;box-sizing: border-box; }
    .bnr_right { width: 300px; box-sizing: border-box; }
    
    /*=====sch_a_con=====*/
    .sch_a_con {
      position: relative;
      margin: 0px 0px 40px;
      box-sizing: border-box;
    }
    
    .sch_a_con .more_btn_span {
      display: inline-block;
      margin-top: 10px;
      padding-left: 1.5px;
      font-size: 13px;
      line-height: 2;
      color: #999999;
      cursor: pointer;
      text-decoration: underline;
    }
    
    .sch_a_con .session_user_list .more_btn_p {
      position: relative;
      font-size: 13px;
      line-height: 1.54;
      text-align: left;
      color: #666666;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-wrap: break-word;
      word-break: break-word;
    }
    .sch_a_con .session_user_list .more_btn_p.on {
      display: block;
      overflow: unset;
    }
    .sch_a_con .more_btn_span small {
      text-decoration: underline;
    }
    
    /*=====sch_b_con=====*/
    .sch_b_con {
      margin-bottom: 30px;
    }
    .sch_b_con:last-child{margin-bottom:0;}
    .sch_wrapper h3 {
      font-size: 22px;
      font-weight: bold;
      text-align: left;
      color: #333333;
    }
    .timeline_h4 {
      display: flex;
      align-items: center;
      flex-basis: 100%;
      font-size: 15px;
      font-weight: bold;
      text-align: left;
      line-height: normal;
      color: #6a6af8;
      margin-bottom: 6px;
      height: 28px;
    }
    
    .timeline_h4:after {
      content: "";
      flex-grow: 1;
      width: auto;
      height: 1px;
      background: #6a6af8;
      font-size: 0;
      line-height: 0;
      margin-left: 10px;
    }
    .livebtn_float {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 4px;
    }
    .livebtn_float .live_time {
      display: inline-block;
      font-size: 20px;
      font-weight: bold;
      color: #6a6af8;
      line-height: 24px;
    }
    .livebtn_float .onair_btn {
      margin-right: 4px;
    }
    .sch_b_con .session_name h5 {
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      color: #333333;
      line-height: 1.5;
      display: -webkit-box;
      word-wrap: break-word;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .sch_b_con .more_btn_span {
      display: inline-block;
      font-size: 13px;
      line-height: 2;
      color: #999999;
      cursor: pointer;
      text-decoration: underline;
      margin-bottom:20px;
    }
    .sch_b_con .more_btn_span.on {
      position: unset;
      bottom: auto;
      right: auto;
    }
    .sch_b_con .more_btn_span.on b {
      display: none;
    }
    .sch_b_con .pre{
      display:inline-block;
      margin-top:20px;
    }
    .sch_b_con .pre h4 {
      margin-bottom: 10px;
    }
    .sch_wrapper .basic_btn {
      width:auto;
      min-width:160px;
      padding:5px 10px;
      margin-right: 10px;
      cursor: pointer;
      font-weight: bold;
      font-size: 14px;
      margin-left:auto;
      min-height:48px;
      line-height:1.4;
      height:unset;
    }
    
    .basic_btn.basic_btn_off {
      background: #ddd;
      cursor: unset;
    }
    .sch_wrapper .ent_span {
      font-size:13px;
      display: inline-block;
      margin-top: 10px;
      word-break:keep-all;
      color: #6a6af8;
    }
    .sch_wrapper .ent_span .time_b {
      display:inline-block;
      font-size:13px;
      margin-right:4px;
      color: #4e4b7b;
    }
    .sch_wrapper .ent_span small {
      font-size:13px;
      color: #666666;
      display: inline-block;
    }
    .sch_wrapper .ent_span span{
      font-size:13px;
      color: #666666;
    }
    .sch_b_con .session_user_list.on {
      display: none;
    }
    .sch_b_con .more_btn_p {
      position: relative;
      font-size: 15px;
      line-height: 1.54;
      text-align: left;
      color: #646464;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-wrap: break-word;
      word-break: break-word;
      margin-top:20px;
    }
    .sch_b_con .more_btn_p.on {
      display: block;
      overflow: unset;
    }

    
    .sch_b_con .session_name span {
      display: block;
      font-size: 16px;
      line-height: 1.63;
      text-align: left;
      color: #666666;
    }
    
    /*=====slide_con=====*/
    .slide_con {position: static;}
    .slide_con:after{content:"";display:block;clear:both;}
    .slide_con .swiper-container {padding-bottom: 30px; margin-bottom: 30px; }
    .slide_flex{
      display:flex;
      align-items: flex-start;
      width:50%;
      float:left;
      padding-top:20px;
      padding-right:20px;
      margin-bottom:10px;
      cursor:pointer;
    }
    .slide_flex:nth-child(odd){clear:both;}
    .slide_flex:nth-child(even){padding-right:0;}
    .slide_con_1 .slide_flex{width:100%;}
    .swiper-container .slide_flex { width: auto; margin-right: 0;}
    .slide_flex .slide_flex_div { position: relative; width: 58px; height: 58px; margin-right: 10px;}
    .slide_flex .slide_flex_t{width:100%; }
    .slide_flex .slide_flex_inner_div { position: relative; width: inherit; height: inherit; }
    .slide_flex .slide_img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color:#D0D0DE;
      border-radius: 50%;
      overflow: hidden;
    }
    .slide_flex .slide_img_more {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 23px;
      height: 23px;
      background-size:cover;
      background-position:center center;
    }
    .slide_flex .slide_flex_t div { display: flex; justify-content: flex-start; margin-bottom: 5px;}
    .slide_flex .slide_flex_t h2 {
      font-size: 14px;
      text-align: left;
      color: #464F60;
      font-weight: 700;
      margin: 2px 0;
      line-height: 20px;
    }
    .slide_flex .slide_flex_t b {
      font-size: 11px;
      display:block;
      height:14px;
      line-height: 14px;
      font-weight: 400;
      color: #464f60;
    }
    
    .slide_flex .slide_flex_t p {
      font-size: 11px;
      text-align: left;
      line-height: 14px;
      color: #464F60;
      word-break:break-word;
    }
    .slide_flex .slide_flex_t p span {display: inline-block; font-size: 11px;}
    .slide_flex .slide_flex_t p span:first-child{margin-right:3px;}
    .slide_con .swiper-pagination { bottom: 0;}
    .slide_con .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      background: #fff;
      border: 2px solid #373779;
      box-sizing: border-box;
      opacity: 1;
    }
    .slide_con .swiper-pagination-bullet-active {
      background: #373779;
    }
    .banner_box_swiper_box {
      position: static;
      margin-bottom: 30px;
    }
    .banner_box_swiper_box .swiper-pagination {
      bottom: 0px;
    }
    .banner_box_swiper_box .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      background: #fff;
      border: 2px solid #373779;
      box-sizing: border-box;
      opacity: 1;
    }
    .banner_box_swiper_box .swiper-pagination-bullet-active {
      background: #373779;
    }
    
    .slider_banner_box {
      width: inherit;
      height: auto;
      border-radius: 6px;
      overflow: hidden;
      cursor: pointer;
    }
    .slider_banner_box a {
      display: block;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
    .slider_banner_box img {
      width: 100%;
      height: 100%;
      display: block;
    }
    /*=====pre_reg_box=====*/
    .pre_reg_box {
      width: 300px;
      min-height: 140px;
      padding: 20px;
      box-sizing: border-box;
      background-image: linear-gradient(to bottom, #6460b1, #5533b1);
      border-radius: 6px;
      margin-bottom: 20px;
      cursor: pointer;
    }
    .pre_reg_box h2 {
      font-size: 26px;
      text-align: left;
      color: #fff;
      margin-bottom: 25px;
      word-break: keep-all;
    }
    .pre_reg_box b {
      display: block;
      font-size: 15px;
      text-align: left;
      color: #fff;
      line-height: 24px;
      margin-bottom: 5px;
    }
    .pre_reg_box p {
      font-size: 15px;
      text-align: left;
      color: #fff;
      line-height: 20px;
      font-weight: normal;
    }
    .banner_box {
      margin-bottom: 30px;
      height: auto;
      border-radius: 6px;
      overflow: hidden;
    }

    .r_notice h2 {
      font-size: 20px;
      text-align: left;
      color: #333;
      margin-bottom: 25px;
    }
    .r_notice p {
      text-align: left;
      color: #333;
      line-height: 1.54;
    }
    .r_notice p span {
      display: block;
    }
    /*=========사전등록페이지 모바일가로, 맥북, 탭===========*/
    @media (min-width: 768px) and (max-width: 1023px) {
      .sch_wrap {
        display: block;
      }
      .sch_wrapper {
        width: 100%;
        padding-right:0;
      }
      .bnr_right {
        width: 100%;
        margin-top: 60px;
        margin-bottom: 50px;
      }
      .pre_reg_box {
        width: 100%;
      }
    }
    /*======사전등록페이지 모바일======*/
    @media (max-width: 767px) {
      .slide_con{margin-bottom:20px;}
      .sch_wrap{flex-direction: column;}
      .sch_wrapper{width:100%; padding-right:0;}
      .bnr_right{width:100%;}
      .sch_wrapper .basic_btn{width:100%;}
      .sch_wrapper .ent_span{margin-top:9px;}
      .sch_section .pre_reg_box { 
        max-width: 800px;
        width: 100%;
        margin-bottom: 20px;
      }
      .pre_reg_box {
        min-height: 140px;
        padding: 20px;
        box-sizing: border-box;
        background-image: linear-gradient(to bottom, #6460b1, #5533b1);
        border-radius: 6px;
        cursor: pointer;
      }
      .pre_reg_box h2 {
        font-size: 20px;
        text-align: left;
        color: #fff;
        margin-bottom: 25px;
      }
      .pre_reg_box b {
        display: block;
        font-size: 15px;
        text-align: left;
        color: #fff;
        line-height: 24px;
        margin-bottom: 5px;
      }
      .pre_reg_box p {
        font-size: 15px;
        text-align: left;
        color: #fff;
        line-height: 20px;
        font-weight: normal;
      }

      .m_banner_box {
        width: 100%;
        max-width: 800px;
        border-radius: 6px;
        height: 190px;
        overflow: hidden;
        margin-bottom:20px;
      }
      .m_banner_box a {
        display: block;
        width: 100%;
        height: 100%;
      }
      .m_banner_box a img {
        width: 100%;
        display: block;
        height: 100%;
      }
      .m_banner_box_swiper_box {
        position: static;
        margin-bottom:20px;
      }
      .m_banner_box_swiper_box .swiper-container {
        padding-bottom: 30px;
      }
      .m_banner_box_swiper_box .swiper-pagination {
        bottom: 0px;
      }
      .m_banner_box_swiper_box .swiper-pagination-bullet {
        width: 12px;
        opacity: 1;
        height: 12px;
        background: #fff;
        border: 2px solid #373779;
        box-sizing: border-box;
      }
      .m_banner_box_swiper_box .swiper-pagination-bullet-active {
        background: #373779;
      }
    
      .m_banner_box2 {
        min-height: 120px;
        background: #f7f7fa;
        margin-bottom: 12px;
    
        border-radius: 6px;
      }
      .m_banner_box_swiper_box2 {
        position: static;
      }
      .m_banner_box_swiper_box2 .swiper-container {
        margin-right: -20px;
      }
    
      .r_notice {
        margin-bottom: 30px;
      }
      .r_notice p span {
        display: inline-block;
        margin-right: 10px;
      }
      .m_slide_con .swiper-container {
        position: static;
        margin-right: -20px;
        padding-bottom:0;
      }
      .m_slide_con .swiper-container .swiper-wrapper .swiper-slide{width:auto;}
      .m_slide_con .slide_flex {
        display: flex;
        width: fit-content;
        float: left;
      }
      .m_slide_con .swiper-slide .slide_flex .slide_flex_div {
        position: relative;
        width: 58px;
        height: 58px;
        margin-right: 15px;
      }
      .m_slide_con .swiper-slide .slide_flex .slide_flex_inner_div {
        position: relative;
        width:58px;
        height: 58px;
      }
    
      .m_slide_con .swiper-slide .slide_flex .slide_img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .m_slide_con .swiper-slide .slide_flex_t h2 {
        font-size: 15px;
        text-align: left;
        line-height: 1.54;
        color: #333;
      }
      .m_slide_con .swiper-slide .slide_flex_t p {
        font-size: 12px;
        line-height: 1.3;
        text-align: left;
        color: #999999;
      }

      .m_slide_con .swiper-slide .slide_flex_t p span {display: inline-block; font-size:11px;}
      .m_slide_con .swiper-slide .slide_flex_t p span:first-child{margin-right:3px;}
      .sch_section .sch_b_con{margin-bottom:40px;}
      .sch_section .sch_b_con .timeline_h4 {
        margin-bottom: 13px;
      }
      .sch_section .sch_b_con .timeline_h4 span {
        font-size: 15px;
      }
      .sch_section .sch_b_con .session_name h5 {
        font-size: 20px;
        line-height: 1.4;
      }
      .sch_section .sch_b_con .session_user_list .more_btn_p{
        margin-top:0;
        margin-bottom:20px;
      }
      .sch_section .sch_b_con .session_user_list > .more_btn_p.on {
        display: block;
        margin-top: 10px;
      }
      .sch_section .pre {
        width: 100%;
      }
      .sch_section .ent_span {
        line-height: 1.71;
        color: #6a6af8;
        text-align: center;
      }
      .sch_section .ent_span .time_b {
        color: #4e4b7b;
      }
      .sch_section .ent_span small {
        color: #666666;
      }
      .sch_section .basic_btn {
        width: 100%;
        font-weight: bold;
      }
    }
    
    /*==============사전등록 모달창=================*/
    
    #registModal {
      position: fixed;
      max-width: 830px;
      width: 90%;
      height: auto;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 6px;
      background: #fff;
      padding-right: 0 !important;
    }
    .modal_header {
      background: #f8f8fe;
      padding: 20px;
      box-sizing: border-box;
    }
    .modal_header > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .modal_header h2 {
      font-size: 26px;
      font-weight: 900;
      line-height: 1.5;
      color: #111111;
    }
    .modal_header p {
      font-size: 13px;
      line-height: 1.63;
      color: #666666;
      margin-top: 5px;
    }
    .modal_content {
      padding: 25px 30px;
      box-sizing: border-box;
      height: calc(100vh - 335px);
      background: #fff;
      overflow-y: auto;
      min-height: 200px;
    }
    
    .modal_content p {
      line-height: 1.3;
    }
    .modal_content .modify_wrapper {
      margin-bottom: 30px;
    }
    .modal_content .modify_wrapper:last-child {
      margin-bottom: 0;
    }
    .addition_content .modify_wrapper ul li {
      float: unset;
      margin-bottom: 20px;
      width: 100%;
    }
    .modal_content h3 {
      font-size: 22px;
      font-weight: bold;
      line-height: 1.5;
      color: #333333;
      margin-bottom: 18px;
    }
    .modal_content .modify_wrapper .mypage_input {
      color: #333;
      border-bottom: 1px solid #ccc;
    }
    .modal_bg {
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.8);
      z-index: 9999;
    }
    .modal_bg.on {
      display: block;
    }
    .modal_content1 li {
      display: flex;
      position: relative;
      border-radius: 4px;
      border: 2px solid #f9f9f9;
      padding: 20px;
      box-sizing: border-box;
      margin-bottom: 10px;
      cursor: pointer;
    }
    .modal_content1 li.active {
      box-shadow: 6px 6px 20px 0 rgba(106, 106, 248, 0.2);
      border: solid 2px #6a6af8;
    }
    @media (hover: hover) {
      .modal_content1 li:hover {
        box-shadow: 6px 6px 20px 0 rgba(106, 106, 248, 0.2);
        border: solid 2px #6a6af8;
      }
    }
    
    .modal_content1 li.active img {
      display: block;
    }
    .modal_content1 li h4 {
      font-size: 15px;
      border-right: 1px solid #eeeeee;
      font-weight: bold;
      line-height: 1.3;
      color: #333333;
      box-sizing: border-box;
      margin-right: 20px;
      padding-right: 20px;
    }
    .modal_content1 li div h5 {
      margin-bottom: 8px;
    }
    .modal_content1 li div span {
      font-size: 13px;
      line-height: 1.63;
      text-align: left;
      color: #666666;
    }
    .modal_content1 li img {
      display: none;
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
    }
    .modal_footer {
      border-radius: 0 0 6px 6px;
      background: #f8f8fe;
      min-height: 88px;
    }
    
    .modal_footer div {
      padding: 20px 30px;
    }
    .modal_footer div button {
      border-radius: 4px;
      color: #fff;
      width: 160px;
      height: 48px;
      box-sizing: border-box;
    }
    .modal_footer div button.modal_prev_btn {
      font-size: 16px;
      background: #a5adb9;
    }
    .modal_footer div button.modal_next_btn {
      font-size: 16px;
      background: #6a6af8;
    }
    .modal_footer1 div {
      text-align: right;
    }
    #registModal .close_btn {
      position: relative;
      background: none;
      cursor: pointer;
      padding: 0;
    }
    .modal_footer2 {
      display: flex;
      justify-content: space-between;
    }
    
    .agree_container {
      margin-top: 30px;
    }
    
    .agree_container input[id="service_agree"],
    .agree_container input[id="privacy_agree"] {
      display: none;
    }
    .agree_container input[id="privacy_agree"] + label span,
    .agree_container input[id="service_agree"] + label span {
      display: inline-block;
      width: 24px;
      height: 24px;
      background: url("${ChkIcon}");
      background-repeat: no-repeat;
      cursor: pointer;
      vertical-align: text-bottom;
      margin-right: 5px;
    }
    
    .agree_container input[id="service_agree"]:checked + label span,
    .agree_container input[id="privacy_agree"]:checked + label span {
      background: url("${ChkOnIcon}");
    }
    .agree_container .privacy_agree_box_inner label,
    .agree_container .service_agree_box_inner label {
      display: flex;
      align-items: center;
      font-weight: bold;
      color: #4e4b7b;
    }
    .agree_container .privacy_agree_box_inner label b,
    .agree_container .service_agree_box_inner label b {
      display: inline-block;
    }
    .privacy_agree_box {
      margin-bottom: 30px;
    }
    .privacy_agree_box_inner,
    .service_agree_box_inner {
      margin-bottom: 10px;
    }
    .privacy_agree_inner_textbox,
    .service_agree_inner_textbox {
      background: #f7f7fa;
      padding: 10px;
      box-sizing: border-box;
      height: 94px;
      overflow-y: auto;
    }
    
    .privacy_agree_inner_textbox p,
    .service_agree_inner_textbox p {
      font-size: 13px;
      line-height: 20px;
    }
    
    .modal_content3 {
      position: relative;
      height: 550px;
    }
    .modal_content3 > div {
      position: absolute;
      bottom: 20px;
      left: 30px;
    }
    .modal_content3 p {
      font-size: 52px;
      font-weight: 900;
      line-height: 1.48;
      text-align: left;
      color: #111111;
      margin-bottom: 20px;
    }
    .modal_content3 span {
      display: block;
      font-size: 13px;
      line-height: 1.63;
      text-align: left;
      color: #666666;
    }
    .modal_footer3 {
      text-align: right;
    }
    .brand_logo_popup {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 600px;
      background: #f7f7fa;
      padding: 140px 20px 30px;
    }
    .brand_logo_popup_inner {
      width: 360px;
      margin: 0 auto 80px;
    }
    .brand_logo_popup_inner h2 {
      font-size: 40px;
      font-weight: 900;
      line-height: 1.48;
      text-align: center;
      color: #111111;
      margin-bottom: 110px;
    }
    .brand_logo_popup_inner a {
      display: block;
      font-size: 20px;
      font-weight: bold;
      line-height: 1.2;
      text-align: left;
      color: #6a6af8;
      margin-bottom: 20px;
    }
    .brand_logo_popup_inner span {
      display: block;
      line-height: 1.63;
      text-align: left;
      color: #666666;
      margin-bottom: 50px;
    }
    .brand_logo_popup_inner button {
      border-radius: 4px;
      background-color: #6a6af8;
      color: #fff;
      font-size: 16px;
      padding: 17px 120px;
    }
    .brand_logo_popup_btm h4 {
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #333333;
      margin-bottom: 10px;
    }
    .brand_logo_popup_btm p {
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.63;
      letter-spacing: normal;
      text-align: left;
      color: #888888;
    }
    /*======사전등록모달창 모바일=======*/
    @media (max-width: 767px) {
      #registModal {
        position: fixed;
        top: 0;
        left: 0;
        transform: unset;
        border-radius: 0;
        width: 100%;
        height: 100%;
        max-height: fit-content;
      }
      .modal_header {
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;
        padding: 10px 20px;
        z-index: 999;
      }
      .modal_header h2 {
        font-size: 20px;
      }
    
      .modal_content {
        padding: 141px 30px 25px;
        overflow-y: auto;
        height: calc(100vh - 78px);
      }
      .modal_content1 li div {
        width: 85%;
        word-break: keep-all;
      }
      .modal_content3 {
        padding: 116px 0 0 0;
        height: calc(100vh - 78px);
      }
      .modal_content1 h3 {
        display: none;
      }
      .modal_content1 li {
        flex-direction: column;
      }
      .modal_content1 li h4 {
        border-right: 0;
        margin-bottom: 20px;
        font-weight: bold;
      }
      .modal_content1 li h4:after {
        content: none;
        width: 20px;
        height: 1px;
        background: #eee;
        display: block;
        margin: 10px 0;
      }
      .modal_content1 li div span {
        font-size: 12px;
      }
      .modal_content .modify_wrapper {
        padding: 0;
      }
      .modify_wrapper ul li {
        float: unset;
        width: 100%;
      }
      .modal_footer {
        position: fixed;
        width: 100%;
        left: 0;
        bottom: 0;
        min-height: 78px;
      }
      .modal_footer div {
        padding: 10px 20px;
        width: 100%;
        height: 100%;
      }
      .modal_footer1 div button {
        width: 100%;
        font-size: 16px;
        font-weight: bold;
      }
      .modal_footer2 div {
        width: auto;
        padding: 10px 0;
      }
      .modal_footer2 div:first-child {
        padding-left: 20px;
        padding-right: 5px;
      }
      .modal_footer2 div:nth-child(2) {
        padding-right: 20px;
        padding-left: 5px;
      }
      .modal_footer3 div button {
        width: 100%;
      }
    
      .agree_container {
        width: 100%;
        margin: 0;
        flex-direction: column;
        background: #fff;
        margin-top: 30px;
      }
    
      .agree_container > li {
        width: 100%;
        margin-right: 0;
        margin-bottom: 20px;
      }
    
      .agree_container > li:last-child {
        margin-bottom: 0;
      }
      .agree_container > div:nth-child(2) {
        margin-bottom: 0;
      }
      .modal {
        padding-right: 0 !important;
      }
      .modal_content3 p {
        font-size: 40px;
        font-weight: 900;
        line-height: 1.48;
        text-align: left;
        color: #111111;
        margin-bottom: 20px;
      }
      .modal_content3 span.modal_content3_span {
        display: inline-block;
        margin-bottom: 30px;
      }
    }
    /*==============동반참석 모달창=================*/
      #accompany_modal{
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 90%;
        max-width: 830px;
        border-radius: 6px;
        overflow: hidden;
      }
      #accompany_modal .modal_header{border-radius: 6px 6px 0 0;}
      #accompany_modal .modal_header > div{
        align-items:flex-start;
      }
      #accompany_modal .modal_content{
        padding:20px;
        height:auto;
        margin-top:-1px;
        min-height:unset;
      }
      #accompany_modal .modal_content h4{
        font-size: 16px;
        font-weight: bold;
        color: #111;
        margin-bottom:10px;
      }
      #accompany_modal .modal_content h5{
        color:#6a6af8; font-size: 13px; font-weight: bold;
      }
      #accompany_modal .modal_content p{
        line-height:1.7;
        color: #666;
      }
      
      #accompany_modal .modal_content2{padding:0;}
      
      #accompany_modal .modal_content2 .modal_content_inner{
        background:#f7f7fa;
        padding:20px;
        overflow-y: auto;
        max-height: 265px;
      }
      #accompany_modal .modal_content2 .modal_content_inner li{display:flex; align-items:center; margin-bottom:10px;}
      #accompany_modal .modal_content2 .modal_content_inner li:last-child{
        margin-bottom:0;
      }
      #accompany_modal .modal_content2 .modal_content_inner li .accompany_list_imgbox{display:flex;}
      #accompany_modal .modal_content2 .modal_content_inner li img{display:inline-block; cursor:pointer;}
      #accompany_modal .modal_content2 .modal_content_inner li img:first-child{
        margin-right:10px;
      }
      #accompany_modal .modal_content2 .accompany_list{
        width:calc(100% - 100px);
        background:#fff;
        padding:10px 20px;
        border-radius:6px;
        margin-right:10px;
      }
      #accompany_modal .modal_content2 .accompany_list.active{
        border:1px solid #ef3232;
      }
      #accompany_modal .modal_content2 .accompany_list > div{
        display:flex;
        align-items:center;
      }
      #accompany_modal .modal_content2 .accompany_list span{
        display:block;
        width:6%;
        text-align:center;
        font-weight: bold;
        font-size: 16px;
        color: #333;
        margin-right: 10px;
      }
      #accompany_modal .modal_content2 .accompany_list span.m_index_num{display:none;}
      #accompany_modal .modal_content2 .accompany_list span.p_index_num{display:block;}
      #accompany_modal .modal_content2 .accompany_list input{
        border:none;
        border-bottom:1px solid #cccccc;
        width:47%;
        height:40px;
      }
      #accompany_modal .modal_content2 .accompany_list input:nth-child(2){
        margin-right:10px;
      }
      #accompany_modal .modal_content2 .accompany_list input:hover{
        border-bottom-color:#7758fa;
      }
      #accompany_modal .modal_content2 > .btn_container{
        justify-content:space-between;
      }
      #accompany_modal .modal_content2 .accompany_list > div.errorMsg{
        display:block;
        padding: 10px 0 0px 50px;
        color:#ef3232;
      }
      #accompany_modal .modal_content2 .accompany_list div.m_errorMsg{display:none;}
      #accompany_modal .modal_content_3 .modal_content_inner{
        margin-top:20px;
        overflow-y: auto;
        max-height: 265px;
      }
      #accompany_modal .modal_content_3 .modal_content_inner li{
        display:flex;
        align-items: center;
        border-bottom: 1px solid #eeeeee;
        padding: 12px 0;
      }
      #accompany_modal .modal_content_3 .modal_content_inner li span,
      #accompany_modal .modal_content_3 .modal_content_inner li strong{display:inline-block; margin-right:10px; color:#333; }
      #accompany_modal .modal_content_3 .modal_content_inner li span{font-weight:bold;}
      #accompany_modal .modal_content_3 .modal_content_inner li strong{ margin-right:30px; width: 150px; white-space: nowrap; font-weight: normal;overflow: hidden;}
      #accompany_modal .modal_content_3 .modal_content_inner li p{font-size: 13px;
        line-height: 1.69;
        text-align: left;
        color: #666;
      }
      #accompany_modal .modal_content_3 .modal_content_inner li:last-child{
        margin-bottom:20px;
      }
      #accompany_modal .modal-footer1{padding:10px 0 20px; margin-top:-1px; background:#fff;}
      #accompany_modal .modal-footer1 > .btn_container {display:flex;justify-content:center; margin:0; font-size:16px;}
      
      #accompany_modal .modal-footer{padding:0;}
      #accompany_modal .accompany_btn{
        display:inline-block;
        width: 200px;
        height:40px;
        color: #fff;
        border-radius: 4px;
        font-size: 15px;
        font-weight: 600;
        background-color: #906af8;
        margin:0;
      }
      #accompany_modal .modal-footer{justify-content:space-between; background:#fff; border-top:none;padding:20px;}
      #accompany_modal .modal-footer .accompany_btn{background-color:#a5adb9;}
      #accompany_modal .modal-footer2 .accompany_btn:first-child{width:80px;}
      #accompany_modal .modal-footer2 .accompany_btn:last-child{width:100px;}
      #accompany_modal .modal-footer3{padding:0;}
      #accompany_modal .modal-footer3 .accompany_btn:first-child{width:80px;}
      #accompany_modal .modal-footer3 .accompany_btn:last-child{width:100px;}

      /*동반참석 모바일*/
      @media (max-width:767px){
        #accompany_modal{
          top:20px;
          transform:translateX(-50%);
          width: calc(100% - 40px);
          height: calc(100% - 40px);
          border-radius: 6px;
          max-height: 620px;
        }
        #accompany_modal .modal_content2 .accompany_list > div.errorMsg{display:none;}
        #accompany_modal .modal_content2 .accompany_list div.m_errorMsg{display:block; color:#ef3232; padding-top:10px;}
        #accompany_modal .modal_header > div{align-items:center;}
        #accompany_modal .modal_content{
          margin-top:60px;
          padding: 20px 20px 20px;
          overflow-y: auto;
          height: calc(100% - 128px);
        }
        #accompany_modal .modal_content2{
          padding:0;
        }
        
        #accompany_modal .modal_content2 .modal_content_inner{
          height: calc(100% - 181px);
          max-height:unset;
        }
        #accompany_modal .modal_content2 .accompany_list{width:100%; display:flex;}
        #accompany_modal .modal_content2 .accompany_list > div{
          flex-direction: column;
          align-items: flex-start;
          width:100%;
        }
        #accompany_modal .modal_content2 .accompany_list span{line-height: 40px;}
        #accompany_modal .modal_content2 .accompany_list span.p_index_num{display:none;}
        #accompany_modal .modal_content2 .accompany_list span.m_index_num{display:block;}
        #accompany_modal .modal_content2 .accompany_list input{
          margin-top:5px;
          margin-bottom:5px;
          width:100%;
        }
        #accompany_modal .modal_content2 .accompany_list input:nth-child(2){
          margin-right:0;
          margin-bottom:10px;
          margin-top:0;
        }
        #accompany_modal .modal_content2 .modal_content_inner li .accompany_list_imgbox{flex-direction:column-reverse;}
        #accompany_modal .modal_content2 .modal_content_inner li img:first-child{
          margin-right:0;
        }
        #accompany_modal .modal_content2 .modal_content_inner li img:nth-child(2){
          margin-bottom:10px;
        }
        #accompany_modal .modal_content_3 .modal_content_inner{max-height:unset;}
        #accompany_modal .modal-footer,#accompany_modal .modal-footer1{padding:10px 20px;}
        #accompany_modal .modal-footer1 .accompany_btn{font-size:13px;}
        #accompany_modal .modal-footer1 > .btn_container span{display:block; font-size:11px;}
        #accompany_modal .modal-footer2 .accompany_btn:first-child,
        #accompany_modal .modal-footer2 .accompany_btn:last-child,
        #accompany_modal .modal-footer3 .accompany_btn:first-child,#accompany_modal .modal-footer3 .accompany_btn:last-child{width:49%;}
        #accompany_modal .accompany_btn{
          width: 49%;
          height: 48px;
          font-size:16px;
        }
        #accompany_modal .modal-footer{
          position:fixed;
          bottom: 0;
          left:0;
          width:100%;
          padding:10px 20px;
          background:#f7f7fa;
        }
      }
    /*=============로그인창 푸터 개인정보처리방침, 사이트이용약관==============*/
    .login_ft_modal_container .ft_modal_content table{
      border: none;
      border-collapse: collapse;
      empty-cells: show;
      margin-bottom: 1em;
      margin-top: 1em;
      max-width: 100%;
    }
    .login_ft_modal_container .ft_modal_content table tbody tr td{
      border: 1px solid #dadada;
      min-width: 2em;
      padding: 0.4em;
      -webkit-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
      vertical-align: middle;
    }
    .ft_modal_container {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 90%;
      max-width: 1180px;
      background: #fff;
      z-index: 99999;
      border-radius: 6px;
      overflow: hidden;
    }
    
    .ft_modal_header {
      background: #f8f8fe;
      padding: 25px 30px;
      box-sizing: border-box;
    }
    .ft_modal_header > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .ft_modal_header h2 {
      font-size: 26px;
      font-weight: 900;
      line-height: 1.5;
      color: #111111;
    }
    .ft_modal_header p {
      font-size: 16px;
      line-height: 1.63;
      color: #666666;
      margin-top: 5px;
    }
    .ft_modal_content {
      line-height: 1.54;
      padding: 25px 30px;
      box-sizing: border-box;
      height: calc(100vh - 300px);
      background: #fff;
      color:#666;
      overflow-y: auto;
    }

    /*======로그인창 푸터 개인정보처리방침 모바일, 사이트이용약관 모바일=======*/
    @media (max-width: 767px) {
      .ft_modal_container {
        width: 100%;
        top: 0;
        left: 0;
        transform: unset;
        max-height: none;
        height: 100%;
        border-radius: 0;
      }
    
      .ft_modal_header {
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;
        padding: 8px 20px;
        z-index: 999;
      }
      .ft_modal_header h2 {
        font-size: 18px;
      }
    
      .ft_modal_content {
        margin-top: 60px;
        padding: 20px;
        overflow-y: auto;
        height: calc(100% - 60px);
      }
    }
    
    /*=============스피커 프로필 모달창=================*/
    .speaker_profile_container .close_btn {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 40px;
      height: 40px;
      background: none;
      cursor: pointer;
      padding: 0;
    }
    .speaker_profile_container .close_btn.m_width_close_btn,
    .m_width_inform_text{display:none;}
    .profile_img {
      position: relative;
      width: 240px;
      overflow: hidden;
      background: rgba(0, 0, 0, 0.3);
    }
    
    .profile_img img.profile_image {
      width: 162px;
      height: 162px;
      display: block;
      margin: 70px auto 20px;
      z-index: 9999;
      border-radius: 50%;
      background-color:#D0D0DE;
    }
    .profile_img img.background_img {
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      -webkit-filter: blur(60px);
      -moz-filter: blur(60px);
      -o-filter: blur(60px);
      -webkit-filter: blur(60px);
      filter: blur(60px);
      backdrop-filter: blur(60px);
      z-index: -1;
      min-width:300px;
      min-height:900px;
    }
    .profile_img .profile_content pre {
      font-family: "Noto Sans KR", sans-serif;
    }
    .profile_img .profile_content_top_text {
      margin:0 35px;
    }
    .profile_img .profile_content_top_text h2 {
      font-size: 22px;
      color: #fff;
      margin-bottom: 10px;
      word-break: break-all;
    }
    .profile_img .profile_content_top_text p {
      font-size: 13px;
      line-height: 1.63;
      color: #fff;
      word-break: break-all;
    }
    .profile_content {
      width: calc(100% - 240px);
      background: #fff;
    }
    .profile_content_top {
      display: flex;
      justify-content: space-between;
      padding: 20px;
    }
    .profile_content_top h2 {
      font-size: 26px;
      font-weight: 900;
      color: #111111;
      line-height: initial;
    }
    
    .profile_content_mid {
      padding: 20px 35px;
      max-height: calc(100% - 77px);
      overflow: auto;
      width: 100%;
    }
    
    .profile_content_mid table{
      border: none;
      border-collapse: collapse;
      empty-cells: show;
      margin-bottom: 1em;
      margin-top: 1em;
      max-width: 100%;
    }
    .profile_content_mid table tbody tr td{
      border: 1px solid #dadada;
      min-width: 2em;
      padding: 0.4em;
      -webkit-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
      vertical-align: middle;
    }
    .profile_content_mid h3 {
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 10px;
    }
    .profile_content_mid p {
      line-height: 1.63;
      color: #666666;
    }
    .profile_content_mid pre {
      font-family: "Noto Sans", sans-serif;
      width: 100%;
      white-space: break-spaces;
      font-size: 13px;
      line-height: 1.63;
      letter-spacing: normal;
      color: #666666;
    }
    .m_profile_content_top {
      display: none;
    }
    /*=====프로필 모달창 모바일 가로모드====*/
    @media (orientation: landscape) and (max-width: 950px) and (max-device-height: 500px){
      .profile_content_top{display:none;}
      .m_profile_flex{
        overflow-y: auto;
        height: 100%;
      }
      .m_width_inform_text{
        display:block;
        margin: 0 auto;
        margin: 20px 0 0 20px;
        font-size: 20px;
        color: #fff;
        text-align: left;
      }
      .m_width_close_btn{display:block;}
      .profile_content_mid{padding: 20px 50px 20px 20px; height: calc(100vh - 50px);}
      .speaker_profile_container .close_btn.m_width_close_btn{display:block; right:10px;}
      .profile_img img.profile_image{width:120px; height:120px; margin:10px auto 15px;}
      .profile_img .profile_content_top_text{text-align:center;}
    }
    /*=================스피커 프로필 모바일 모달창==================*/
    @media (max-width: 767px) {
      .profile_content_top {
        display: none;
      }
      .m_profile_content_top {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .m_profile_content_top h2 {
        font-size: 20px;
        color: #fff;
      }
      .m_profile_content_top .close_btn .line {
        background: #fff;
      }
      .speaker_profile_container {
        position: unset;
        top: auto;
        left: auto;
        transform: unset;
        width: 100%;
        flex-direction: column;
        min-height: auto;
        max-height: 100%;
        border-radius: 0;
      }
      .speaker_profile_container .close_btn {
        position: absolute;
        top: 5px;
        right: 10px;
      }
      .m_profile_flex{display:flex; align-items:center;}
      .profile_img {
        width: 100%;
        padding: 15px 20px 50px;
        box-sizing: border-box;
        height: 100%;
        max-height: 240px;
      }
      .profile_img img.profile_image {
        width: 100px;
        height: 100px;
        margin: 30px 20px 30px 0;
      }
      .profile_img img.background_img {
        top: 20%;
      }
      .profile_img .profile_content_top_text {
        text-align: left;
        margin:0;
      }
      .profile_content {
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
        height: calc(100vh - 240px);
        overflow-y: auto;
      }
      .profile_content_mid {
        margin-bottom: 0;
        padding: 0;
        max-height: 100%;
        overflow-y: unset;
      }
      .profile_content_mid pre {
        padding: 20px;
      }
      .modal-backdrop {
        display: none !important;
      }
    }
    
    /*=========alert=========*/
    .alert_container {
      width: 500px;
      height: 180px;
      padding: 20px;
      box-sizing: border-box;
    }
    .alert_container p {
      color: #666;
      line-height: 26px;
      margin-bottom: 25px;
    }
    .alert_container div {
      text-align: center;
    }
    .alert_container div button {
      width: 130px;
      height: 40px;
      background: #6a6af8;
      color: #fff;
      border-radius: 4px;
    }
    .modal {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: rgba(0,0,0,0.5);
    }
    .modal-dialog {
      min-width: 832px;
      min-height: 743px;
    }



    /*사전등록 페이지*/
    .preregister_con{
      width:100%;
      margin:20px auto 0;
      margin-bottom:40px;
      box-sizing: border-box;
    }
    .preregister_con .swiper-container{border-radius:6px;}
    .preregister_con .swiper-container .swiper-slide{width:100%;}
    .preregister_con .swiper-pagination-bullets{
      bottom: 20px;
      left: 20px;
      text-align: left;
    }
    .preregister_con .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      background: none;
      border: 2px solid #373779;
      box-sizing: border-box;
      opacity: 1;
    }
    .preregister_con .swiper-pagination-bullet-active {
      background: #373779;
    }

    .MuiTypography-root i.required {
      font-family: 'Noto Sans KR';
      font-style: inherit;
      color:unset;
      margin-left:2px;
    }
    /**
     * ==============================================
     * Dot Flashing
     * ==============================================
     */
    .snippet_box{
      margin: 15px auto;
    }
    .dot-flashing {
      position: relative;
      width: 10px;
      height: 10px;
      border-radius: 5px;
      background-color: #7878a5;
      color: #7878a5;
      animation: dotFlashing 1s infinite linear alternate;
      animation-delay: .5s;
    }

    .dot-flashing::before, .dot-flashing::after {
      content: '';
      display: inline-block;
      position: absolute;
      top: 0;
    }

    .dot-flashing::before {
      left: -15px;
      width: 10px;
      height: 10px;
      border-radius: 5px;
      background-color: #7878a5;
      color: #7878a5;
      animation: dotFlashing 1s infinite alternate;
      animation-delay: 0s;
    }

    .dot-flashing::after {
      left: 15px;
      width: 10px;
      height: 10px;
      border-radius: 5px;
      background-color: #7878a5;
      color: #7878a5;
      animation: dotFlashing 1s infinite alternate;
      animation-delay: 1s;
    }

    @keyframes dotFlashing {
      0% {
        background-color: #7878a5;
      }
      50%,
      100% {
        background-color: #ebe6ff;
      }
    }
    @media (max-width: 767px) {
      .preregister_con .swiper-container{
        padding-bottom:40px
      }
      .preregister_con .swiper-pagination-bullets{
        bottom: 0px;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
      }
    }
    /*사전등록 페이지 끝*/
    
    .sch_inform{
      margin-bottom:60px;
    }
    .sch_inform h2{
      font-size: 32px;
      font-weight: bold;
      text-align: left;
      color: #333;
      margin-bottom:10px;
    }
    .sch_inform p{
      font-size: 15px;
      line-height: 1.47;
      text-align: left;
      color: #666;
      margin-bottom:20px;
    }
    .sch_inform ul{display:flex; align-items:center;}
    .sch_inform ul li{position:relative; margin-right:20px;}
    .sch_inform ul li:after{
      content:"";
      display:block;
      position:absolute;
      top:50%;
      transform:translateY(-50%);
      right:0;
      background:#ccc;
    }
    .sch_inform ul li a{
      font-size: 15px;
      font-weight: bold;
      line-height: 2.4;
      text-align: left;
      color: #6a6af8;
    }

    .offline{
      display:inline-block;
      border-radius: 12px;
      background:#723ec6;
      color:#fff;
      margin-right:4px;
      padding:1px 10px;
    }

    /*=============푸터================*/
    .footer-arrow-wrap {
      position: fixed;
      bottom: -100px;
      right: 20px;
      width: 50px;
      height: 56px;
      text-align: center;
      background: #333333;
      opacity: 0.7;
      border-radius: 2px;
      box-shadow: 2px 2px 8px 0 rgba(157, 157, 157, 0.45);
      transition: all 0.3s;
      z-index: 9999;
    }
    .footer-arrow-wrap:hover {
      background: #6a6af8;
    }
    .footer-arrow-wrap.active {
      bottom: 20px;
      transition: all 0.3s;
    }
    .footer-arrow-wrap button {
      display: block;
      width: 100%;
      height: 100%;
      padding: 0;
    }
    .footer-arrow-wrap span {
      display: block;
      color: #fff;
      font-size: 15px;
      line-height: 20px;
      font-weight: bold;
    }
    #footer {
      background-color: #f7f7fa;
      padding: 30px 20px 70px;
      box-sizing: border-box;
    }
    .footer {
      max-width: 1180px;
      margin: 0 auto;
      box-sizing:border-box;
    }
    .footer h2 {
      font-size: 15px;
      font-weight: bold;
      line-height: 1.5;
      text-align: left;
      color: #333333;
      margin-bottom: 10px;
    }
    .footer .ft_info {
      font-family: "Noto Sans KR",'Apple SD Gothic Neo',sans-serif;
      color:#666666;
      line-height: 1.54;
      text-align: left;
      white-space: break-spaces;
      word-break: keep-all;
    }
    .footer .ft_info table{
      border: none;
      border-collapse: collapse;
      empty-cells: show;
      margin-bottom: 1em;
      margin-top: 1em;
      max-width: 100%;
    }
    .footer .ft_info table tr td{
      border: 1px solid #dadada;
      min-width: 2em;
      padding: 0.4em;
      -webkit-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
      vertical-align: middle;
    }
    .ft_info2 {
      font-size: 13px;
      font-weight: bold;
      line-height: 1.85;
      text-align: left;
      color: #333333;
    }
    .ft_info2 a:first-child {
      display: inline-block;
      margin-right: 10px;
    }
    .ft_info2 a {
      cursor: pointer;
    }
    .ft_info3 span {
      font-size: 13px;
      line-height: 1.85;
      text-align: right;
      color: #888888;
      text-transform: uppercase;
      text-decoration: none !important;
    }
    .ft_info2_flex {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
    }
    #footer .ft_modal_content table{
      border: none;
      border-collapse: collapse;
      empty-cells: show;
      margin-bottom: 1em;
      margin-top: 1em;
      max-width: 100%;
    }
    #footer .ft_modal_content table tr td{
      border: 1px solid #dadada;
      min-width: 2em;
      padding: 0.4em;
      -webkit-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
      vertical-align: middle;
    }

    /*=======푸터 모바일========*/
    @media (max-width: 767px) {
      #footer {
        padding: 30px 20px;
      }
      .footer h2 {
        font-size: 15px;
      }
      .footer-arrow-wrap {
        right: 10px;
      }
      .footer-arrow-wrap.active {
        bottom: 20px;
      }
      .footer .ft_info2 {
        line-height: 1.7;
        margin-bottom: 10px;
      }
      .footer .ft_info2_flex {
        display: block;
        margin-bottom: 33px;
      }
    }
    `;

export default defaultStyle;